export default "__VITE_ASSET__88c7954f__"